import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/types';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  const formatViews = (views: number): string => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${manga.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          title={`${manga.title} - 免费在线漫画阅读`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 text-xs rounded-full text-white whitespace-nowrap ${
            manga.status === '连载中' ? 'bg-primary-500' : 'bg-secondary-500'
          }`}>
            {manga.status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-0.5 bg-foreground-950/70 text-white text-xs px-1.5 py-0.5 rounded-full">
          <i className="ri-star-fill text-yellow-400 text-[10px]"></i>
          <span>{manga.rating}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-foreground-900 text-sm truncate group-hover:text-primary-600 transition-colors">
          {manga.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{manga.author}</p>
        <div className="flex items-center justify-between mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(manga.views)}
          </span>
          <span className="bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded whitespace-nowrap">
            {manga.category}
          </span>
        </div>
      </div>
    </Link>
  );
}